import { useState, useEffect } from 'react'
import { X } from 'lucide-react'
import { hasHoursQuota, usageRatio, formatHoursUsed, formatHoursQuota } from '../../lib/usage.js'

const KEY = 'clarity_usage_banner_dismissed'

export default function UsageBanner({ usage }) {
  const [dismissedFor, setDismissedFor] = useState(() => sessionStorage.getItem(KEY) || '')

  useEffect(() => {
    if (usage && dismissedFor && dismissedFor !== usage.monthly_period) {
      sessionStorage.removeItem(KEY)
      setDismissedFor('')
    }
  }, [usage, dismissedFor])

  if (!hasHoursQuota(usage)) return null
  const ratio = usageRatio(usage)
  if (ratio < 0.8 || ratio >= 1) return null
  if (dismissedFor === usage.monthly_period) return null

  const onDismiss = () => {
    sessionStorage.setItem(KEY, usage.monthly_period)
    setDismissedFor(usage.monthly_period)
  }

  return (
    <div className="flex flex-wrap items-center gap-2 bg-amber-100 px-4 py-2 text-[12px] text-amber-900 sm:flex-nowrap sm:justify-between sm:text-[12.5px]">
      <span className="min-w-0 flex-1">
        {formatHoursUsed(usage.monthly_seconds_used)} / {formatHoursQuota(usage.monthly_seconds_quota)} d&apos;enregistrement utilisées ce mois. Passer au Cabinet pour 30 h/mois ?
      </span>
      <button onClick={onDismiss} aria-label="Fermer" className="ml-auto shrink-0 rounded p-1 hover:bg-amber-200">
        <X size={14} />
      </button>
    </div>
  )
}
